import { menuController } from "@ionic/core/components";
import { IonContent, IonMenu } from "@ionic/react";
import { useMemo } from "react";
import LogOutOutlineIcon from "shared/components/icons/LogOutOutlineIcon";
import PillarForm from "shared/components/pillar-form/PillarForm";
import { useCustomRouter } from "shared/context/CustomRouterContext";
import { useCustomSession } from "shared/context/CustomSessionContext";
import AdminImpersonateInfo from "hub/src/components/admin/AdminImpersonateInfo";
import { SocietyLogo } from "hub/src/components/common/SocietyLogo";
import { HubRoutesList } from "hub/src/components/sideMenu/HubRoutesList";

const MENU_ID = "hub-side-menu";
const ROUTE_URLS_WITHOUT_SIDE_MENU = [
  "/",
  "/login",
  "/account/new",
  "/account/recover",
];

const HubSideMenu = () => {
  const router = useCustomRouter();
  const session = useCustomSession();

  const isMenuDisabled = useMemo(() => {
    return ROUTE_URLS_WITHOUT_SIDE_MENU.some(
      (route) => router.pathname === route,
    );
  }, [router.pathname]);

  return (
    <IonMenu
      type="overlay"
      menuId={MENU_ID}
      contentId="main-content"
      // The side menu should not be visible on some pages
      disabled={isMenuDisabled}
      data-testid={MENU_ID}
    >
      <IonContent className="border-r border-sidebar-border ios-side-menu-wrapper">
        <div className="hub-sidebar-menu-container flex flex-col h-full justify-between">
          <div className="flex flex-col grow bg-[inherit]">
            <AdminImpersonateInfo />

            <div className="flex items-center gap-2 px-3 pt-3.5 pb-3 border-b border-sidebar-border">
              <SocietyLogo className="h-9.5 w-9.5 mb-0.5" />
              <h2>{session.society?.abbreviation}</h2>
            </div>

            <HubRoutesList
              className="grow !mt-0 bg-[inherit]"
              routes={session.society!.routes!}
              onRouteClick={() => menuController.close(MENU_ID)}
            />

            <div
              key="special-action-bank"
              className="menu-action-bank border-t border-sidebar-border"
            >
              {session.societyUserId ? (
                <PillarForm.LoadingButton
                  className="menu-action-bank-button"
                  onClick={async () => await session.logout!()}
                >
                  <LogOutOutlineIcon className="sidebar-menu-svg ion-like-icon" />
                  Sign Out
                </PillarForm.LoadingButton>
              ) : (
                <PillarForm.LoadingButton
                  className="menu-action-bank-button"
                  onClick={async () => router.push("/login")}
                >
                  <LogOutOutlineIcon className="sidebar-menu-svg ion-like-icon" />
                  Login / Create Account
                </PillarForm.LoadingButton>
              )}
            </div>
          </div>
        </div>
      </IonContent>
    </IonMenu>
  );
};

export default HubSideMenu;
